//#region modules
import { AngularReactBrowserModule } from '@angular-react/core';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
//#endregion

//#region amobee / react components
import { LineItemModule } from '@amobee/angular-components';
import { ReactComponentsModule } from './react-components/react-components.module';
import { AclNgxModule } from '@amobee/acl-ngx';
//#endregion

//#region external depedencies
import { AmobeeSlideoutComponent } from './components/slideout/amobee-slideout.component';
import { AutoCompleteModule } from './components/auto-complete/auto-complete.module';
import { NgMultiSelectDropDownModule } from './components/ng-multiselect-dropdown/ng-multiselect-dropdown.module';
import { CheckboxTreeModule } from './components/checkbox-tree/checkbox-tree.module';
import { ModalModule } from './components/modal/modal.module';
import { DirectivesModule } from './directives/directives.module';
import { AclCollapsibleNavItemsWrapperComponent } from './components/acl-collapsible-nav-items-wrapper/acl-collapsible-nav-items-wrapper.component';
import { TimezonePipe } from './pipes/timezone.pipe';
import { RangeSliderComponent } from './components/range-slider/range-slider.component';
import { DaypartingGridComponent } from './components/dayparting-grid/dayparting-grid.component';
import { TargetingContainerComponent } from './components/targeting-container/targeting-container.component';
import { BrowseAndSelectComponent } from './components/browse-and-select/browse-and-select.component';
import { BrowseIncludeExcludeComponent } from './components/browse-include-exclude/browse-include-exclude.component';
import { CommonModule } from '@angular/common';
import { BrowseFilterPipe } from './components/browse-include-exclude/browse-filter.pipe';
import { DataTableModule } from './components/data-table/data-table.module';
//#endregion

const components = [
    TimezonePipe,
    BrowseFilterPipe,
    AmobeeSlideoutComponent,
    AclCollapsibleNavItemsWrapperComponent,
    RangeSliderComponent,
    DaypartingGridComponent,
    TargetingContainerComponent,
    BrowseAndSelectComponent,
    BrowseIncludeExcludeComponent
];

@NgModule({
    declarations: components,
    imports: [
        AngularReactBrowserModule,
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        ReactComponentsModule,
        AclNgxModule,
        NgMultiSelectDropDownModule,
        HttpClientModule,
        CheckboxTreeModule,
        DataTableModule,
        ModalModule,
        AutoCompleteModule,
        DirectivesModule,
        LineItemModule
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ],
    exports: [
        ...components,
        ReactComponentsModule,
        AclNgxModule,
        NgMultiSelectDropDownModule,
        CheckboxTreeModule,
        DataTableModule,
        ModalModule,
        AutoCompleteModule,
        DirectivesModule,
        LineItemModule
    ]
})
export class AppCommonModule { }
